import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useFlowDetectionsLastRecord({ enabled = true }) {
  const { getFlowDetectionsLastRecord } = useApi();
  const { data, isPending } = useQuery({
    queryKey: ["flow-detections-last-record"],
    queryFn: () => getFlowDetectionsLastRecord(),
    enabled,
  });

  const lastRecord = data?.data;

  return { data: lastRecord, isPending };
}
